import {appInstance} from '@/utils/app-accessor'
import {authStore} from '@/composables/store-accessor'
import {PersonRole} from '~/utils/types/types'

export default defineNuxtRouteMiddleware(() => {
    const companyType = authStore.companyType
    const companyRole = authStore.personRole
    const isCRMCampaignOption = runtimeStore.getCRMOption('asp.option.marketing.campaigns')

    if (
        companyType !== 'TOUR_OPERATOR_1LEVEL' &&
        ![PersonRole.Supervisor, PersonRole.Director, PersonRole.Support].includes(companyRole) &&
        !isCRMCampaignOption
    ) {
        throw createError({statusCode: 403, message: appInstance.$i18n.t('error_message.forbidden')})
    }
})
